<template>
  <div class="grid-x grid-padding-x grid-padding-y pega-form">
    <template v-if="$slots.label">
      <slot name="label" />
    </template>
    <div
      v-else-if="label"
      class="medium-3 cell pega-form-label"
    >
      {{ label }}
    </div>
    <div class="auto cell">
      <fieldset>
        <template v-for="(option, i) in options">
          <label
            :key="i"
            class="pega-input"
          >
            <input
              :data-test="'option-' + i"
              :type="type"
              :value="option.id"
              :class="className"
              :name="name"
              :checked="value.includes(option.id)"
              :disabled="disabled"
              @change="update"
            >{{ option.name }}
          </label>
        </template>
      </fieldset>
      <template v-if="$slots.error">
        <slot name="error" />
      </template>
    </div>
  </div>
</template>

<style scoped>
input {
  cursor: pointer;
}
</style>

<script>
export default {
  props: {
    type: {
      type: String,
      default: 'checkbox'
    },
    label: {
      type: String,
      default: ''
    },
    className: {
      type: String,
      default: ''
    },
    value: {
      type: Array,
      default: () => []
    },
    options: {
      type: Array,
      required: true
    },
    name: {
      type: String,
      default: 'form-item-group'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      values: []
    }
  },
  watch: {
    value (val) {
      this.$set(this, 'values', val)
    }
  },
  methods: {
    update (e) {
      if (this.type === 'checkbox') {
        if (e.target.checked) {
          this.values.push(Number(e.target.value))
        } else {
          this.values = this.values.filter(v => v !== Number(e.target.value))
        }
        this.$emit('input', this.values)
        this.$emit('change', this.values)
      } else {
        this.$emit('input', e.target.value)
        this.$emit('change', e.target.value)
      }
    }
  }
}
</script>
